import React from 'react';
import { useState } from 'react';

import passwordImg from '../../../png/password.png';
import passwordVisibleImg from '../../../png/passwordVisible.png';
import loginImg from '../../../png/username.png';
import Policy from './Policy';
import Terms from './Terms';

import {
  Img,
  InputWrapper,
  Form,
  FormGroup,
  Input,
  EntranceButton,
  PrivatePolicy,
  Link,
  Bottom,
} from './styled';

interface IProps {
  submit: (e: React.FormEvent<HTMLFormElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  login: string;
  password: string;
  submitText: string;
  isRegister: boolean;
  setIsRegister: (data: boolean) => void;
}

const FormComponent: React.FC<IProps> = (props) => {
  const [isPasswordVisible, setPasswordVisible] = useState<boolean>(false);
  const [termsVisible, setTermsVisible] = useState<boolean>(false);
  const [policyVisible, setPolicyVisible] = useState<boolean>(false);

  return (
    <Form onSubmit={props.submit}>
      <FormGroup>
        <InputWrapper>
          <Input
            type="email"
            name="login"
            placeholder="E-mail"
            value={props.login}
            onChange={props.onChange}
          />
          <Img src={loginImg} alt="login" />
        </InputWrapper>
      </FormGroup>
      <FormGroup>
        <InputWrapper>
          <Input
            type={isPasswordVisible ? 'text' : 'password'}
            name="password"
            placeholder="Пароль"
            value={props.password}
            onChange={props.onChange}
          />
          <Img
            src={isPasswordVisible ? passwordVisibleImg : passwordImg}
            alt="password"
            isPassword
            onClick={() => setPasswordVisible(!isPasswordVisible)}
          />
        </InputWrapper>
      </FormGroup>
      {policyVisible && (
        <FormGroup>
          <InputWrapper>
            <PrivatePolicy>
              <Policy
                openTerms={() => {
                  setTermsVisible(true);
                }}
                close={() => {
                  setPolicyVisible(false);
                }}
              />
            </PrivatePolicy>
          </InputWrapper>
        </FormGroup>
      )}
      {termsVisible && (
        <FormGroup>
          <InputWrapper>
            <PrivatePolicy>
              <Terms
                close={() => {
                  setTermsVisible(false);
                }}
              />
            </PrivatePolicy>
          </InputWrapper>
        </FormGroup>
      )}
      <EntranceButton
        hasLoader={props.isLoading}
        disabled={props.isLoading || !props.login || !props.password}
      >
        {props.submitText}
      </EntranceButton>
      <div className="create-links">
        <div>или</div>
        <div
          className="register-link"
          onClick={() => props.setIsRegister(props.isRegister ? false : true)}
        >
          {props.isRegister ? 'Войти' : 'Зарегистрироваться'}
        </div>
      </div>
      <Bottom>
        <Link onClick={() => setTermsVisible(true)}>Пользовательское соглашение</Link>
        <Link onClick={() => setPolicyVisible(true)}>Политика конфиденциальности</Link>
      </Bottom>
    </Form>
  );
};

export default FormComponent;
